/** API error types — kept in their own module so client.ts and mocks.ts share them
 *  without a circular import. */

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** 401 — токен невалиден/просрочен. UI should prompt re-auth. */
export class UnauthorizedError extends ApiError {
  constructor(message = "Сессия истекла. Войдите снова.") {
    super(401, message);
    this.name = "UnauthorizedError";
  }
}

/** 404 — ресурс отсутствует (например, клип удалён по TTL). */
export class NotFoundError extends ApiError {
  constructor(message = "Ресурс не найден") {
    super(404, message);
    this.name = "NotFoundError";
  }
}
